
import { AxiosResponse } from 'axios';
import { OAuth2Client } from '@kolorado/oauth';
import { QueueDisableFaultCodeRequest } from '../entities/disable-fault-codes-v1/queue-disable-fault-code-request';
import { QueueResponsePayload } from '../entities/disable-fault-codes-v1/queue-response-payload';
import { DisableFaultCodeStatusesResponse } from '../entities/disable-fault-codes-v1/disable-fault-code-statuses-response';
import { GetDisabledFaultCodeRequest } from './types';
import { RemoveDisableFaultCodeRequest } from '../entities/disable-fault-codes-v1/remove-disable-fault-code-request';
import { RemoveDisableFaultCodeResponse } from '../entities/disable-fault-codes-v1/remove-disable-fault-code-response';
import { axiosInstance } from "../axios-instance";

class DisableFaultCodes {
  private baseUrl: string;

  private client: OAuth2Client | null;

  constructor(client: OAuth2Client | null, baseUrl: string) {
    this.baseUrl = baseUrl;
    this.client = client;
  }

  queueConfigs(body: QueueDisableFaultCodeRequest): Promise<AxiosResponse<QueueResponsePayload>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.post<QueueResponsePayload>(`${this.baseUrl}/queueConfigs`, body, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  }

  configStatuses(
    queryParameters: GetDisabledFaultCodeRequest,
  ): Promise<AxiosResponse<DisableFaultCodeStatusesResponse>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.get<DisableFaultCodeStatusesResponse>(`${this.baseUrl}/configStatuses`, {
      params: queryParameters,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  }

  removeConfigs(
    body: RemoveDisableFaultCodeRequest,
  ): Promise<AxiosResponse<RemoveDisableFaultCodeResponse>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.post<RemoveDisableFaultCodeResponse>(`${this.baseUrl}/removeConfigs`, body, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  }
}

export default DisableFaultCodes;
